import queries from './queries';
// import custom from './custom';

export const handlers = [
  ...queries,
  // ...custom
];
